export default {"src":"/_next/static/media/manage_services.fc0a0fc6.svg","height":83,"width":102,"blurWidth":0,"blurHeight":0};